<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-club-employee-departments-data-provider
            v-slot="departmentsScope"
            :employee-id="employeeId"
        >
            <div
                class="animated fadeIn"
                style="position: relative; z-index: 1;"
            >
                <kgr-club-employee-departments-relations-form
                    :club-employee-department-relations="departmentsScope.data"
                    :employee-id="employeeId"
                    :club-id="clubId"
                    :error="error"
                    :is-creatable="isDepartmentRelationCreatable"
                    @updated="onUpdate(departmentsScope.reload)"
                />
            </div>
        </kgr-club-employee-departments-data-provider>
        <kgr-club-employee-teams-data-provider
            v-slot="teamScope"
            :employee-id="employeeId"
        >
            <div class="animated fadeIn">
                <kgr-employee-teams-relations-form
                    :club-employee-team-relations="teamScope.data"
                    :employee-id="employeeId"
                    :club-id="clubId"
                    :error="error"
                    :is-creatable="isTeamRelationCreatable"
                    @updated="onUpdate(teamScope.reload)"
                />
            </div>
        </kgr-club-employee-teams-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import ClubEmployeeDepartmentsDataProvider from '../../components/data-provider/ClubEmployeeDepartmentsDataProvider.vue';
import ClubEmployeeTeamsDataProvider from '../../components/data-provider/ClubEmployeeTeamsDataProvider.vue';
import Error from '../../js/model/Error.js';
import FormScaffold from '../../components/common/form/FormScaffold.vue';
import KgrClubEmployeeDepartmentsRelationsForm from '../../components/employees/ClubEmployeeDepartmentRelationsForm.vue';
import KgrEmployeeTeamsRelationsForm from '../../components/employees/ClubEmployeeTeamRelationsForm.vue';

export default {
    components: {
        KgrEmployeeTeamsRelationsForm,
        KgrClubEmployeeDepartmentsRelationsForm,
        'kgr-club-employee-teams-data-provider': ClubEmployeeTeamsDataProvider,
        'kgr-club-employee-departments-data-provider': ClubEmployeeDepartmentsDataProvider,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        employeeId: {
            type: Number,
            required: true,
        },
        isDepartmentRelationCreatable: {
            type: Boolean,
            required: true,
        },
        isTeamRelationCreatable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            error: new Error(),
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onUpdate(reload) {
            reload();
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
